{
  "el": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Αλλαγή λογότυπου (απαιτείται png)",
        "changeThemeColor": "Επιλογή νέου χρώματος θέματος"
      },
      "errors": {
        "themeColorInvalid": "Πληκτρολόγησε έξι χαρακτήρες, 0-9 ή A-F. Για παράδειγμα 096553."
      },
      "labels": {
        "customerThemeColor": "Χρώμα θέματος πελάτη",
        "customerThemeColorExlainer": "Αυτό το χρώμα θα χρησιμοποιείται στην πύλη πελάτη. Κάνε υπόδυση ενός πελάτη για να το δεις σε δράση.",
        "logo": "Λογότυπο"
      },
      "paused": {
        "description": "Ο λογαριασμός σας στο {client} υπάρχει ακόμα, αλλά η πρόσβασή σας είναι προς το παρόν απενεργοποιημένη, οπότε η πλατφόρμα παραμένει κλειστή. Ένας ιδιοκτήτης του οργανισμού σας μπορεί να ενεργοποιήσει ξανά την πρόσβασή σας.",
        "noAccess": "Χωρίς πρόσβαση",
        "open": "Άνοιγμα",
        "title": "Η πρόσβασή σας είναι σε παύση",
        "yourOrganizations": "Οι οργανισμοί σας"
      },
      "picture_logo_format": {
        "round": "Στρογγυλό λογότυπο",
        "square": "Τετράγωνο λογότυπο"
      }
    }
  }
}
